export default "/images/vendor/flag-icons/flags/4x3/cy.svg?e323e5843ba3ef9dcb8edeec51208e05";